import { Component, Input, OnInit } from '@angular/core';
import { UserProfileConstants } from '../../user-profile/user-profile-constants';
import { UserProfile } from '../../user-profile/models/user-profile';
import { UserSkillDto } from '../../user-profile/models/user-skill';
import { UserSkillsByStatusDto } from '../../user-profile/models/user-skills-by-status';
import { TreeNode } from 'primeng/api';
import { UserService } from '../../user-profile/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-profile-details',
  templateUrl: './user-profile-details.component.html',
  styleUrls: ['./user-profile-details.component.scss']
})
export class UserProfileDetailsComponent implements OnInit {
  @Input() userProfile: UserProfile = {} as UserProfile;
  @Input() userAssignedSkills: UserSkillsByStatusDto = {} as UserSkillsByStatusDto;
  @Input() treeData: TreeNode[] = [];
  showConfirmationModal: boolean = false;
  confirmationMessage: string = UserProfileConstants.ConfirmationMessage;
  deleteAttachmentId: string | undefined;
  notApplicableText = UserProfileConstants.NotApplicable;

  constructor(private userService: UserService, private router: Router) {
  }

  ngOnInit(): void {
  }
  
  
  deleteAttachment(attachmentId: string): void {
    this.showConfirmationModal = true;
    this.deleteAttachmentId = attachmentId;
  }

  downloadAttachment(fileId: string, fileName: string): void {
    this.userService.downloadFile(fileId).subscribe((response) => {
      const fileUrl = response.fileUri;
      const downloadLink = document.createElement('a');
      document.body.appendChild(downloadLink);
      downloadLink.setAttribute('style', 'display: none');
      downloadLink.href = fileUrl;
      downloadLink.download = fileName;
      downloadLink.target = '_blank';
      downloadLink.click();
      downloadLink.remove();
    });
  }


  closedConfirmation(closed: boolean): void {
    if (closed) {
      this.showConfirmationModal = false;
    }
  }

  confirmDelete(confirm: boolean): void {
    if (confirm) {
      const attachmentToDelete = this.userProfile.attachments?.find(
        (attachment) => attachment.attachmentId === this.deleteAttachmentId
      );

      if (attachmentToDelete?.attachmentFileId) {
        this.userService.deleteFile(attachmentToDelete.attachmentFileId).subscribe({
          next: () => {
            this.removeDeletedAttachment();
          },
          error: () => {
            this.removeDeletedAttachment();
          }
        });
      } else {
        this.removeDeletedAttachment();
      }

      this.showConfirmationModal = false;
    }
  }

  /// <summary>
  /// Removes the deleted attachment from the UI.
  /// </summary>
  private removeDeletedAttachment(): void {
    this.userService.removeAttachment(this.userProfile.puid, this.deleteAttachmentId!).subscribe(() => {
      if (this.userProfile.attachments) {
        this.userProfile.attachments = this.userProfile.attachments.filter(
          (attachment) => attachment.attachmentId !== this.deleteAttachmentId
        );
      }
      this.deleteAttachmentId = undefined;
    });
  }

  /// <summary>
  /// TrackBy function for *ngFor loops over skills.
  /// Improves performance by preventing unnecessary DOM updates.
  /// </summary>
  trackBySkillCode(index: number, skill: UserSkillDto): string {
    return skill.skillCode;
  }

  /// <summary>
  /// TrackBy function for *ngFor loops over security permissions.
  /// Improves performance by preventing unnecessary DOM updates.
  /// </summary>
  trackByPermission(index: number, permission: string): string {
    return permission;
  }

  /// <summary>
  /// TrackBy function for *ngFor loops over attachments.
  /// Improves performance by preventing unnecessary DOM updates.
  /// </summary>
  trackByAttachmentId(index: number, attachment: any): string {
    return attachment.attachmentId;
  }

  /// <summary>
  /// Handles navigation to skill details.
  /// Can be extended for future routing to skill detail page.
  /// </summary>
  viewSkillDetails(skillCode: string, skillName: string): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([
        '/eqms.skillDetails/' + skillCode
      ])
    );
    window.open(url, '_blank');
  }
}
